import { TranslateService } from '@ngx-translate/core'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'

import { OrderStatus, SortOrder } from 'app/pages/account/orders/utils/orders.utils'

export function fetchOrderTranslations(translateService: TranslateService): Observable<any> {
  const keys = [
    'ORDER_STATUS.all',
    'ORDER_STATUS.newOrder',
    'ORDER_STATUS.inProgress',
    'ORDER_STATUS.shipped',
    'ORDER_STATUS.partiallyShipped',
    'ORDER_STATUS.cancelled',
    'ORDER_STATUS.onHold',
    'ORDER_STATUS.notPaid',
    'ORDER_STATUS.refund',
    'SORT_OPTIONS.dateOldestToNewest',
    'SORT_OPTIONS.dateNewestToOldest',
    'SORT_OPTIONS.priceLowToHigh',
    'SORT_OPTIONS.priceHighToLow',
    'ERROR.translationFailed'
  ]

  return translateService.get(keys).pipe(
    map(translations => ({
      statusOptions: [
        { label: translations['ORDER_STATUS.all'], value: OrderStatus.All },
        { label: translations['ORDER_STATUS.newOrder'], value: OrderStatus.NewOrder },
        { label: translations['ORDER_STATUS.inProgress'], value: OrderStatus.InProgress },
        { label: translations['ORDER_STATUS.shipped'], value: OrderStatus.Shipped },
        {
          label: translations['ORDER_STATUS.partiallyShipped'],
          value: OrderStatus.PartiallyShipped
        },
        { label: translations['ORDER_STATUS.cancelled'], value: OrderStatus.Cancelled },
        { label: translations['ORDER_STATUS.onHold'], value: OrderStatus.OnHold },
        { label: translations['ORDER_STATUS.notPaid'], value: OrderStatus.NotPaid },
        { label: translations['ORDER_STATUS.refund'], value: OrderStatus.Refund }
      ],
      sortOptions: [
        {
          label: translations['SORT_OPTIONS.dateOldestToNewest'],
          value: { field: 'created_at', order: SortOrder.Asc }
        },
        {
          label: translations['SORT_OPTIONS.dateNewestToOldest'],
          value: { field: 'created_at', order: SortOrder.Desc }
        },
        {
          label: translations['SORT_OPTIONS.priceLowToHigh'],
          value: { field: 'total', order: SortOrder.Asc }
        },
        {
          label: translations['SORT_OPTIONS.priceHighToLow'],
          value: { field: 'total', order: SortOrder.Desc }
        }
      ],
      translationsError: translations['ERROR.translationFailed']
    }))
  )
}
